import React from 'react';
import { useTranslation } from 'react-i18next';
import { InformSpan } from '../../form';
import useAuth from '../../../../auth/feature/auth';
import { getHeadersData } from './header-menu.data';
import usePopup from '../../../feature/popup';
import { MenuButton } from './dropdown.component';
import { Container } from './responsive-container.component';
import { CancelIcon } from '../../icons';

const MENU_TEXT_KEYS: Record<string, string> = {
  'My Products': 'header.myProducts',
  Settings: 'header.settings',
  'Log out': 'header.logout',
  Admin: 'header.admin'
};

interface IProps {
  onClose: () => void;
}

export const HeaderMenuDropdown = ({ onClose }: IProps) => {
  const { t } = useTranslation();
  const [width, setWidth] = React.useState(window.innerWidth);
  const { user, isAdmin } = useAuth();
  const { handleModal } = usePopup();
  React.useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return (
    <Container>
      {width < 525 && (
        <div
          onClick={onClose}
          className="absolute right-6 top-6 hover:text-blue-600"
        >
          <CancelIcon />
        </div>
      )}

      <div className="w-full flex flex-col gap-[24px]">
        {getHeadersData(isAdmin).map((data, i) => {
          let { to } = data;
          const handle = () => {
            if (data.popup) {
              handleModal(data.popup);
              to = '';
            } else {
              onClose();
            }
          };
          return (
            <MenuButton
              key={i}
              onClick={handle}
              text={
                MENU_TEXT_KEYS[data.text] ? t(MENU_TEXT_KEYS[data.text]) : data.text
              }
              to={data.to}
              Icon={data.icon}
            />
          );
        })}
      </div>
    </Container>
  );
};
